import script from "./otpCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./otpCheck.vue?vue&type=script&setup=true&lang=js"

import "./otpCheck.vue?vue&type=style&index=0&id=9ae25818&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ae25818"]])

export default __exports__